import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';
import { RegTypes } from 'Types/globals';

export const useRegType = () => {
  // destructuring asPath from next js useRouter hook to get the current path name
  const geo = useSelector((state: IApplicationState) => state.globalReducer.geo);

  return (targetType: RegTypes[] | RegTypes) => {
    if (Array.isArray(targetType)) {
      let eligible = false;

      for (let type of targetType) {
        if (type === geo.reg_type) {
          eligible = true;
          break;
        }
      }
      return eligible;
    }
    return geo.reg_type === targetType?.toString();
  };
};
